import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { SubscriptionProvider } from './context';
import { Loading } from 'react-vant';
import RegionGate from './components/RegionGate';
import RouteErrorBoundary from './components/RouteErrorBoundary';
import RouteTracker from './components/RouteTracker';
import { ROUTE_PATHS } from '@/constants/routePaths';

// 路由级懒加载:按需加载页面 chunk,减小首屏体积
const Service = lazy(() => import('./pages/service/myService'));
const Error = lazy(() => import('./pages/error'));
const Plan = lazy(() => import('./pages/service/plan'));
const Diff = lazy(() => import('./pages/service/diff'));
const Region = lazy(() => import('./pages/region'));
const Sim = lazy(() => import('./pages/sim'));

// 订阅业务布局:只给订阅业务的页面提供 SubscriptionProvider
// RegionGate:地区确认守卫(会话首跳判定国家/俄区分流,未确认时弹地区选择弹窗)
const SubscriptionLayout = () => (
  <SubscriptionProvider>
    <RegionGate>
      <Outlet />
    </RegionGate>
  </SubscriptionProvider>
);

// chunk 加载时的过渡占位
const PageLoading = () => (
  <div className='w-full h-screen flex items-center justify-center bg-[#F7F7F7]'>
    <Loading type='spinner' />
  </div>
);

const Routers = () => {
  return (
    <BrowserRouter>
      <RouteErrorBoundary>
        <Suspense fallback={<PageLoading />}>
          <Routes>
            {/* 原有路由,只被 SubscriptionProvider 包裹 */}
            <Route element={<SubscriptionLayout />}>
              <Route path={ROUTE_PATHS.SERVICE} element={<Service />} />
              <Route path={ROUTE_PATHS.PLAN} element={<Plan />} />
              <Route path={ROUTE_PATHS.DIFF} element={<Diff />} />
              <Route path={ROUTE_PATHS.REGION} element={<Region />} />
              {/* 兜底:Service 依赖 useSubscription(),必须留在 SubscriptionProvider 内 */}
              <Route path={ROUTE_PATHS.FALLBACK} element={<Service />} />
            </Route>

            {/* 新路由,可包裹自己的Provider */}
            {/* <Route element={<XxxLayout />}>
              <Route path='/xxx/a' element={<XxxA />} />
              <Route path='/xxx/b' element={<XxxB />} />
            </Route> */}

            {/* SIM 卡管理:自包含页面,不依赖 SubscriptionProvider */}
            <Route path={ROUTE_PATHS.SIM} element={<Sim />} />
            <Route path={ROUTE_PATHS.ERROR} element={<Error />} />
          </Routes>
          <RouteTracker />
        </Suspense>
      </RouteErrorBoundary>
    </BrowserRouter>
  );
};
export default Routers;
